/**
 * @description: 不需要校验登录态的接口
 */
const ignoreTokenUrl: string[] = [
  '/mp/business/captchaNew',  // 获取验证码
  '/mp/item/activities/activitiesRelationId', // 获取活动商品
  '/mp/member/register', // 注册
  '/mp/global/groundTemplate/templateId/',
  '/mp/item/itemDesc',
  '/mp/order/getPaymentStatus',
  '/mp/global/decorate/qryDictData',
  '/mp/order/jdPayAgreement/cancel/apply',
  '/mp/order/cashierRepayOff',
  '/mp/business/saveMerchantRegister',
  '/mp/member/merchant/register',
  '/mp/member/merchant/upload',
  '/mp/order/contract/preView'
];

export {
  ignoreTokenUrl
};
